import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { ToolbarComponent } from 'src/app/components/toolbar/toolbar.component';
import { MarkdownComponent } from '../../components/markdown/markdown.component';
import { FsLogoComponent } from '../../icons/fs-logo/fs-logo.component';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-study-page',
  templateUrl: './study-page.component.html',
  styleUrls: ['./study-page.component.scss'],
  imports: [RouterLink, MarkdownComponent, AsyncPipe, FsLogoComponent, ToolbarComponent],
})
export class StudyPageComponent {
  #content = inject(ContentService);
  slug = input.required<string>();

  inhalt$ = toObservable(this.slug).pipe(
    map((slug) => this.#content.studyContents().find((s) => s.sluggedTitle === slug))
  );
}
